import { createPropertySelectors } from '@ngxs/store'
import { MapState, MapStateModel } from './map.state'

export class MapStateSelectors {
  static slices = createPropertySelectors<MapStateModel>(MapState)
}
